import styled, { keyframes } from 'styled-components/macro'
import React from 'react'

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
`

const Spinner = styled.div`
  height: ${p => p.size};
  width: ${p => p.size};
  position: absolute;
  top: calc(50vh - ${p => p.theme.header.height});
  left: 50%;
  margin: calc(-${p => p.size} * .5) 0 0 calc(-${p => p.size} * .5);
  animation: ${spin} 1s infinite linear;
  border: 6px solid rgba(${p => p.theme.color.primary}, .2);
  border-radius: 50%;

  &::before {
    content: "";
    display: block;
    position: absolute;
    left: -6px;
    top: -6px;
    height: 100%;
    width: 100%;
    border-top: 6px solid rgba(${p => p.theme.color.primary}, .8);
    border-left: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid transparent;
    border-radius: 100%;
  }
`

export default () => <Spinner size='60px' />
